import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EmployeesTable } from './EmployeesTable/EmployeesTable'

const RequestsPage = () => {
  return (
    <ResponsivePage.Body variant="full">
      <EmployeesTable />
    </ResponsivePage.Body>
  )
}

export default RequestsPage
